<template>
  <div>
    <div class="home_banner">
      <swiper
        ref="mySwiper"
        :slides-per-view="1"
        :space-between="0"
        :speed="1000"
        :effect="'fade'"
        @slideChange="onSlideChange"
      >
        <swiper-slide>
          <div class="banner banner_1">
            <img :src="baseUrl + bannerInfo.iconUrl" alt="">
          </div>
        </swiper-slide>
      </swiper>
      <div class="banner_content">
        <div class="content">
          <div class="banner_content_text">
            <transition key="1" name="text">
              <p v-if="text1" class="title">{{ bannerInfo.title }}</p>
            </transition>
            <transition key="2" name="text">
              <p v-if="text2" class="sub">{{ bannerInfo.shortTitle }}</p>
            </transition>
            <ul>
              <li>
                <transition key="3" name="text">
                  <div v-if="text3">
                    <div class="round" />{{ bannerInfo.remarkArr[0] }}
                  </div>
                </transition>
              </li>
              <li>
                <transition key="4" name="text">
                  <div v-if="text4">
                    <div class="round" />{{ bannerInfo.remarkArr[1] }}
                  </div>
                </transition>
              </li>
              <li>
                <transition key="5" name="text">
                  <div v-if="text5">
                    <div class="round" />{{ bannerInfo.remarkArr[2] }}
                  </div>
                </transition>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <ul>
        <li v-for="(item,index) in bannerInfo.children" :key="index">
          <transition :key="index + 1" name="advantage">
            <div v-show="advantage">
              <img class="sign" :src="baseUrl + item.iconUrl" alt="">
              <div>
                <p class="title">{{ item.title }}</p>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </div>
    <div class="core_framework">
      <div class="head">
        <transition key="6" name="text">
          <div v-show="text6">
            <p class="title">{{ coreInfo.title }}</p>
            <p class="sub">{{ coreInfo.shortTitle }}</p>
          </div>
        </transition>
      </div>
      <div class="content">
        <ul class="core_list">
          <li v-for="(item,index) in coreInfo.children" :key="index">
            <transition key="1" name="core">
              <div v-if="core">
                <div>
                  <img :src="baseUrl + item.iconUrl" alt="">
                  <p class="title">{{ item.title }}</p>
                  <p class="text">{{ item.remark }}</p>
                </div>
              </div>
            </transition>
          </li>
        </ul>
      </div>
      <div class="more" @click="productService">更多</div>
    </div>
    <div class="introduction">
      <div class="content">
        <transition key="7" name="text">
          <div v-show="text7">
            <p class="title">{{ introductInfo.title }}</p>
            <p class="text">{{ introductInfo.shortTitle }}</p>
            <p v-for="(item,index) in introductInfo.remarkArr" :key="index" class="detail">
              {{ item }}
            </p>

          </div>
        </transition>
      </div>
    </div>
    <div class="glory_box">
      <div class="glory">
        <img src="@/assets/images/home/history.png" alt="">
        <div>
          <transition key="8" name="text">
            <div v-show="text8">
              <p class="title">{{ gloryInfo.title }}</p>
              <p class="text">{{ gloryInfo.shortTitle }}</p>
              <p class="detail">{{ gloryInfo.remark }}</p>
            </div>
          </transition>
        </div>
        <ul class="sign">
          <li><img style="width:100px;" src="@/assets/images/home/glory/xinli_logo.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/high-tech.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/CMMI3.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/ISO.png" alt=""></li>
          <li><img style="width:100px;" src="@/assets/images/home/glory/copyright.png" alt=""></li>
        </ul>
        <ul class="honor">
          <li><img style="width:94px;" src="@/assets/images/home/glory/glory1.png" alt=""></li>
          <li><img style="width:84px;" src="@/assets/images/home/glory/glory2.png" alt=""></li>
          <li><img style="width:225px;" src="@/assets/images/home/glory/SRAI.png" alt=""></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { getMenu, getMainContent } from '@/plugin/api'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper-bundle.css'
import 'swiper/components/effect-fade/effect-fade.min.css'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      banner0: true,
      banner1: true,
      advantage: false,
      timer: null,
      text1: false,
      text2: false,
      text3: false,
      text4: false,
      text5: false,
      text6: false,
      text7: false,
      text8: false,
      core: false,
      advantageScroll: true,
      coreScroll: true,
      value: 0,
      bannerInfo: {},
      coreInfo: {},
      introductInfo: {},
      gloryInfo: {},
      menuList: [],
      baseUrl: '/website'
    }
  },
  mounted() {
    this.getInfo()
    window.scrollTo({
      top: 0
    })
    clearInterval(this.timer)
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    setTimeout(() => {
      this.advantage = true
      this.timer = setInterval(() => {
        if (this.value > 4) {
          this.value = 0
          clearInterval(this.timer)
        } else {
          this.value++
          this['text' + this.value] = true
        }
      }, 250)
    }, 1000)
  },
  methods: {
    companyDetail() {
      this.$router.push({ path: '/companyView' })
    },
    productService() {
      const obj = this.menuList.find(item => {
        return item.path === '/productService'
      })
      const query = obj.path === '/productService' ? { urlType: obj.urlType, url: obj.url } : {}
      this.$router.push({ path: '/productService', query })
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.text6 = true
      }
      if (scrollTop > 450 && this.coreScroll) {
        this.coreScroll = false
        this.core = true
      }
      if (scrollTop > 1300) {
        this.text7 = true
      }
      if (scrollTop > 1930) {
        this.text8 = true
      }
    },
    getInfo() {
      getMenu({ tenantId: 'sft' }).then(res => {
        this.menuList = res.data.data.menuList
        const obj = this.menuList.find(item => {
          return item.path === '/'
        })
        const params = {
          tenantId: 'sft',
          url: obj.url || '',
          urlType: obj.urlType || ''
        }
        getMainContent(params).then(res => {
          if (res.data.code === 200) {
            const arr = res.data.data.contentMainList[0].contentItemTreeList
            arr.forEach(item => {
              switch (item.id) {
                case 376:
                  this.bannerInfo = item
                  this.bannerInfo.remarkArr = this.bannerInfo.remark.split('\n').filter(item => {
                    return item !== ''
                  })
                  break
                case 377:
                  this.coreInfo = item
                  break
                case 776:
                  this.introductInfo = item
                  this.introductInfo.remarkArr = this.introductInfo.remark.split('\n').filter(item => {
                    return item !== ''
                  })
                  break
                case 777:
                  this.gloryInfo = item
                  break
              }
            })
          }
        })
      })
    },
    onSlideChange(swiper) {
      // for (let i = 0; i < 2; i++) {
      //   this['banner' + i] = false
      // }
      // this['banner' + swiper.activeIndex] = true
    }
  }
}
</script>

<style lang="scss" scoped>
.core-enter-active{
  animation: slideInRight 2s ease;
}
.text-enter-active{
  animation: fadeIn .5s ease;
}
.banner-enter-active{
  animation: fadeIn 1s ease;
}
.banner-leave-active{
  animation: fadeOut 1s ease;
}
.advantage-enter-active{
  animation: slideInRight 2s ease;
}
.swiper-container{
  height: 100%;
}
.home_banner{
  width: 100%;
  height: 700px;
  background-color: #fff;
  position: relative;
  .banner{
    height: 100%;
    position: relative;
    img{
      height: 100%;
      position: absolute;
      z-index: -1;
      top: 0;
    }
  }
  .banner_content{
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    z-index: 1;
    color: #101010;
    .content{
      width: 1200px;
      min-width: 1200px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .banner_content_text{
        height: 211px;
      }
      .title{
        font-size: 40px;
        font-weight: 600;
        margin-bottom: 12px;
      }
      .sub{
        font-size: 24px;
        margin-bottom: 18px;
      }
      ul{
        margin-bottom: 35px;
        li{
          display: flex;
          align-items: center;
          .round{
            position: relative;
            top: -2px;
            margin-right: 10px;
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 10px;
            background-color: #6C6C6C;
          }
        }
      }
      .detail_box{
        height: 40px;
        .detail{
          display: inline-block;
          padding: 10px 29px;
          color: #fff;
          font-size: 14px;
          border-radius: 3px;
          background: linear-gradient(#00A59E, #2B9BF7);
        }
      }
    }

  }
}
.advantage{
  padding: 50px 0;
  ul{
    display: flex;
    justify-content: center;
    li{
      width: 221px;
      height: 50px;
      align-items: center;
      border-right: 1px solid #BBBBBB;
      padding: 0 50px;
      &:last-child{
        border: none;
      }
      &>div{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .sign{
        margin-right: 15px;
      }
      .title{
        color: #101010;
        font-size: 24px;
      }
      .sub{
        color: #999999;
        font-size: 14px;
      }
    }
  }
}
.more{
  cursor: pointer;
  text-align: center;
  font-size: 20px;
  color: #fff;
  padding-bottom: 75px;
}
.core_framework{
  overflow: hidden;
  background-image: url(../assets/images/home/core_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  .more{
    color: #000;
  }
  .head{
    color: #000;
    text-align: center;
    padding: 150px 0 100px 0;
    .title{
      font-size: 30px;
      margin-bottom: 10px;
    }
    .sub{
      font-size: 20px;
    }
  }
  .content{
    .core_list{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      overflow: hidden;
      li{
        margin-right: 40px;
        margin-bottom: 40px;
        width: 270px;
        height: 360px;
        &:last-child{
          margin-right: 0;
        }
        &:hover{
          &>div>div{
            top: -20px;
          }
        }
        &:nth-child(1)>div:hover{
          background-image: url(../assets/images/home/produc_bg_1.png);
        }
        &:nth-child(2)>div:hover{
          background-image: url(../assets/images/home/produc_bg_2.png);
        }
        &:nth-child(3)>div:hover{
          background-image: url(../assets/images/home/produc_bg_3.png);
        }
        &:nth-child(4)>div:hover{
          background-image: url(../assets/images/home/produc_bg_4.png);
        }
        &>div{
          height: 340px;
          background-image: url(../assets/images/home/produc_bg.png);
          background-repeat: no-repeat;
          background-size: cover;
          border-radius: 4px;
          padding: 0px 40px;
        }
        &>div>div{
          transition: all 0.2s;
          position: relative;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        img{
          margin-top: 20px;
        }
        .title{
          color: #101010;
          font-size: 16px;
          margin: 20px 0;
        }
        .text{
          width: 190px;
          color: #666666;
          font-size: 14px;
        }
      }
    }
  }
}
.glory,.introduction{
  .title{
    color: #00A59E;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .text{
    color: #00A59E;
    font-size: 20px;
    margin-bottom: 50px;
  }
  .detail{
    color: #666666;
    font-size: 14px;
    line-height: 28px;
    width: 710px;
  }
}
.introduction{
  background-image: url(../assets/images/home/intro_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  padding: 150px 0 340px 0;
  .content{
    width: 1200px;
    margin: 0 auto;
    height: 379px;
    .detail{
      text-indent: 2em;
    }
  }
}
.glory_box{
  background-color: #FFF;
}
.glory{
    position: relative;
    padding: 150px 0 36px 0;
    margin: 0 auto;
    width: 1200px;
    max-width: 1200px;
    &>img {
      width: 720px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
    ul{
      display: flex;
      margin-top: 10px;
      align-items: center;
    }
    .sign{
        margin-right: 18px;
    }
    .honor{
      li{
        margin-right: 34px;
      }
    }
}
</style>
